import { AppTopBar } from '../AppTopBar';

export function CustodianTopBar() {
  return (
    <AppTopBar
      homeTo="/custodian"
      homeAriaLabel="UMB eVault — Custodian home"
    />
  );
}
